import { SubmissionError } from 'redux-form';
import { ICEPACKS_REQUIRED_FIELDS, REQUIRED_FIELDS } from './constants';
import { goToElement } from '../../utils/goToElement';

export const transformToValidationErrors = errors => {
	return Object.entries(errors).reduce((prev, [key, error]) => {
		if (key.includes('icepacks') && key !== 'icepacks') {
			const arr = key.split('.');

			if (!prev.icepacks) {
				prev.icepacks = {};
			}

			prev.icepacks = {
				...prev.icepacks,
				[arr[1]]: {
					...(prev.icepacks[arr[1]] || {}),
					[arr[2]]: !arr[3] ? error : { error },
				},
			};
		}

		prev[key] = error;

		return prev;
	}, {});
};

const validateIcepacks = (values, key, index, fields) => {
	fields.forEach(field => {
		if (!values?.icepacks?.[index]?.[field]) {
			const error = { icepacks: [] };
			error.icepacks[index] = { [field]: 'Заполните это поле' };
			goToElement(`${key}.${field}`);
			throw new SubmissionError(error);
		}
	});
};

export const validate = values => {
	REQUIRED_FIELDS.forEach(key => {
		if (key === 'icepacks' && values?.icepacks) {
			Object.keys(values?.icepacks).forEach(idx => {
				validateIcepacks(values, `icepacks[${idx}]`, idx, ICEPACKS_REQUIRED_FIELDS);
			});
		}

		if (values?.[key] === undefined || values?.[key] === '' || values?.[key] === null || values?.[key] === []) {
			goToElement(key);
			throw new SubmissionError({ [key]: 'Заполните это поле' });
		}
	});
};
